// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__K3Fjs","tab":"Tabs_tab__kE2yZ","underline":"Tabs_underline__5SyY4","underline-small":"Tabs_underline-small__MSqgY","small":"Tabs_small__TOwTs"};